import { useMutation, useQueryClient, type UseMutateFunction } from '@tanstack/react-query';
import { companyService } from '../services/company.service';
import type { Company } from '../types/company.types';

export function useCompanyStatus(): {
  activate: UseMutateFunction<Company, Error, string>;
  suspend: UseMutateFunction<Company, Error, string>;
  isLoading: boolean;
  isError: boolean;
  isSuccess: boolean;
  error: Error | null;
} {
  const queryClient = useQueryClient();

  const activateMutation = useMutation({
    mutationFn: (id: string) => companyService.activateCompany(id),
    onSuccess: (_, id) => {
      queryClient.invalidateQueries({ queryKey: ['companies'] });
      queryClient.invalidateQueries({ queryKey: ['company', id] });
    },
  });

  const suspendMutation = useMutation({
    mutationFn: (id: string) => companyService.suspendCompany(id),
    onSuccess: (_, id) => {
      queryClient.invalidateQueries({ queryKey: ['companies'] });
      queryClient.invalidateQueries({ queryKey: ['company', id] });
    },
  });

  return {
    activate: activateMutation.mutate,
    suspend: suspendMutation.mutate,
    isLoading: activateMutation.isPending || suspendMutation.isPending,
    isError: activateMutation.isError || suspendMutation.isError,
    isSuccess: activateMutation.isSuccess || suspendMutation.isSuccess,
    error: activateMutation.error || suspendMutation.error,
  };
}
